import React, { useState } from 'react';
import HeaderLinksContainer from './header-links-mobile.style';

const MobileHeaderLinks = () => {
    const [toggleHidden, setToggleHidden] = useState(false);
    const showMenu = () => setToggleHidden(!toggleHidden);
    return (
        <HeaderLinksContainer>
            <i
                className="fas fa-bars toggle-menu"
                onClick={() => showMenu()}
            ></i>
            {toggleHidden ? (
                <ul>
                    <li>
                        <a href="#Home">Home</a>
                    </li>
                    <li>
                        <a href="#Services">Services</a>
                    </li>
                    <li>
                        <a href="#Portfolio">Portfolio</a>
                    </li>
                    <li>
                        <a href="#Skills">Skills</a>
                    </li>
                    <li>
                        <a href="#Pricing">Pricing</a>
                    </li>
                    <li>
                        <a href="#Contact">Contact</a>
                    </li>
                </ul>
            ) : null}
        </HeaderLinksContainer>
    );
};

export default MobileHeaderLinks;
